import { z } from "zod";

export const simulatorScoreSchema = z
	.number()
	.min(0, "A nota deve ser maior que 0")
	.max(1000, "A nota máxima é 1000");

export const simulatorFormSchema = z.object({
	state: z.string().min(2, "Selecione um estado"),
	course: z.string().min(1, "Selecione um curso"),
	languagesAndCodesScore: simulatorScoreSchema,
	mathematicsScore: simulatorScoreSchema,
	naturalSciencesScore: simulatorScoreSchema,
	humanSciencesScore: simulatorScoreSchema,
	essayScore: simulatorScoreSchema,
});

const gradeSearchField = z.coerce.number().min(0).max(1000).optional();

export const sisuSimulatorSearchSchema = z.object({
	grade_lc: gradeSearchField,
	grade_mt: gradeSearchField,
	grade_cn: gradeSearchField,
	grade_ch: gradeSearchField,
});

export type SisuSimulatorSearch = z.infer<typeof sisuSimulatorSearchSchema>;
